export const getThumbnailUrl = (content, preferredImageType = 'cardImage') => {
  if (!content) {
    return '/images/logo.svg';
  }

  if (content[preferredImageType]) {
    return content[preferredImageType] + '/public';
  }

  if (content.cardImage) {
    return content.cardImage + '/public';
  }
  
  if (content.detailImage) {
    return content.detailImage + '/public';
  }
  
  if (content.trailerImage) {
    return content.trailerImage + '/public';
  }

};

export const ensureThumbnailFallbacks = (content) => {
  if (!content) {
    return {};
  }

  return {
    ...content,
    cardImage: content.cardImage || '/images/logo.svg',
    detailImage: content.detailImage || '/images/logo.svg',
    trailerImage: content.trailerImage || '/images/logo.svg'
  };
}; 